module.exports = __webpack_public_path__ + "img/32.98361b7d.jpg";